module.exports = __webpack_public_path__ + "img/methoden_960.115bd571.png";